
import './audit-campaign-search-screen.scss'

import { defineComponent } from 'vue';

import { SortFilter } from '@skinsoft/types';
import { AuditRoutes } from '@skinsoft/const';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { SearchHeader } from '@skinsoft/search';
import { AuditCampaignFeaturedList } from '../audit-campaign-featured-list';

declare const config
const AUDIT_SORTING_ENTITY_FIELDS: SortFilter[] = config.auditSortingEntityFields
const OFFLINE_AUDIT_SORTING_ENTITY_FIELDS: SortFilter[] = config.offlineAuditSortingEntityFields

export const AuditCampaignSearchScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAuditCampaignFeaturedList: AuditCampaignFeaturedList,
        sSearchHeader: SearchHeader,
    },
    props: ['titleI18NKey', 'searchParams'],
    template: require('./audit-campaign-search-screen.html'),
    data() {
        return {
            nbReports: "",
            sortingEntityFields: [] as any[],
            targetRouteName: AuditRoutes.CAMPAIGN,
        }
    },
    mounted() {
        this.$on('nb-fetched-reports-topic', (message) => {
            this.nbReports = this.$t('listReportScreen.nbResults', { nbResults: message.nbReports }) as string;
        })

        this.updateSortingFields()
        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    },
    methods: {
        updateSortingFields() {
            if(window.navigator.onLine) {
                this.sortingEntityFields = AUDIT_SORTING_ENTITY_FIELDS;
            } else {
                this.sortingEntityFields = OFFLINE_AUDIT_SORTING_ENTITY_FIELDS
            }
        },
    },
})
